import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetClassGradeList = async function(locationId, parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationId}/class-grades${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetClassGrade = async function(classgradePublicId, locationId) {
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationId}/class-grade/${classgradePublicId}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const UpdateClassGrade = async function(classgrade) {
    try {
        const { publicId } = classgrade
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/class-grade/${publicId}`,
            data: classgrade,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const PostClassGrade = async function(data) {
    try {
        if (data === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: data')
            )
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/class-grade`,
            data: data,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const DeleteClassGrade = async function({ classgradePublicId }) {
    try {
        if (classgradePublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: classgradePublicId')
            )
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/class-grade/${classgradePublicId}`,
        })
    } catch (e) {
        console.error(e)
    }
}

export const ChangeClassGradeStatus = async function(parameters) {
    try {
        const { publicId } = parameters
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/class-grade/${publicId}/change-status`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}
